<template>
  <el-pagination small v-bind="$attrs" :total="total" :layout="layout" :background="background" :page-size.sync="pageSize" :current-page.sync="currentPage" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
</template>

<script  >
export default {
  name: 'Pagination',
  props: {
    page: { type: Number, default: 1 },
    total: { type: Number, default: 0 },
    limit: { type: Number, default: 10 },
    pageSizes: { type: Number, default: 10 },
    background: { type: Boolean, default: false },
    layout: { type: String, default: 'total, prev, pager, next, jumper' },
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit('update:page', val);
      },
    },
    pageSize: {
      get() {
        return this.limit;
      },
      set(val) {
        this.$emit('update:limit', val);
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: this.currentPage, limit: val });
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-pagination {
  text-align: center;
  margin: 20px 0px;
  /deep/ li,
  /deep/button,
  /deep/.el-input__inner {
    background: transparent !important;
  }
}
</style>
